import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object, string } from "yup";
import { showToast } from "src/utils/showToaster";
import { useAddCategoryMutation } from "src/services/CategoryService";
import { CategoryFormValues } from "src/models/Category.model";
import CategoryForm from "../Layouts/CategoryForm";

type Props = {
  onClose: () => void;
};

const AddCategoryWrapper = ({ onClose }: Props) => {
  // Form Initial Values
  const initialValues: CategoryFormValues = {
    categoryName: "",
    categoryCode: "",
    rank: "",
  };

  // Validation Schema
  const validationSchema = object().shape({
    categoryName: string().required("Please enter category name"),
    categoryCode: string().required("Please enter category code"),
  });

  const [addCategory] = useAddCategoryMutation();

  // Handle Submit
  const handleSubmit = (
    values: CategoryFormValues,
    { setSubmitting, resetForm }: FormikHelpers<CategoryFormValues>
  ) => {
    const payload = {
      categoryName: values.categoryName,
      rank: Number(values.rank),
      categoryCode: values.categoryCode,
    };
    addCategory(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="xs" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <CategoryForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddCategoryWrapper;
